import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import RubricaTableRow from './RubricaTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import PdfButton from '../PdfButton'

class RubricaTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }


    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    onExportClick(tipo){
        if (this.props.onExportRubrica !== undefined){
            this.props.onExportRubrica(tipo)
        }
    }

    onPdfExportClick(tipo){
        if (this.props.onExportRubricaPdf !== undefined){
            this.props.onExportRubricaPdf(tipo)
        }
    }

    

    render() {   
        
        let btnNuovoSoggetto = null;
        if (this.props.readOnly == false){
            btnNuovoSoggetto = (<Link to={`/app/rubrica/new`}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="plus icon"></i> Nuovo Soggetto
                    </div>
                </Link>         );   
        }
 
        return (<table className="ui striped sortable compact celled table">
            <thead>
            <tr><th colSpan="4">
                {btnNuovoSoggetto}
                <a href="#" onClick={(ev) => (this.onExportClick('csv'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file csv outline icon"></i> Esporta in CSV
                    </div>
                </a>
                <a href="#" onClick={(ev) => (this.onExportClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Esporta in Excel
                    </div>
                </a>
                <PdfButton title="PDF Completo" onClick={(ev) => (this.onPdfExportClick("completo"))} />
                <PdfButton title="PDF Compatto" onClick={(ev) => (this.onPdfExportClick("compatto"))} />

                {/*<PrintButton />*/}
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    className="five wide"
                    name="soggetto"
                    orderActive={this.props.tableOrderingField === "soggetto"}
                    orderFields="s.cognome,s.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Soggetto</TableColumnOrdered>
                <TableColumnOrdered
                    className="three wide"
                    name="dipartimento"
                    orderActive={this.props.tableOrderingField === "dipartimento"}
                    orderFields="d.nome,s.cognome,s.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Dipartimento</TableColumnOrdered>
                <TableColumnOrdered
                    className="three wide"
                    name="organizzazione"
                    orderActive={this.props.tableOrderingField === "organizzazione"}
                    orderFields="o.nome,d.nome,s.cognome,s.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Organizzazione</TableColumnOrdered>

                <th className="one wide no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((item) => (
                this.props.senderList.every((sender, index, array) => {
                      return sender.soggetto.idSoggetto !== item.idSoggetto
                }) ?
                    <RubricaTableRow item={item} key={item.idSoggetto} canAddSoggetto={true}  onAddSoggetto={this.props.onAddSoggetto} onDeleteSoggetto={this.props.onDeleteItem} readOnly={this.props.readOnly}/>
                :
                    <RubricaTableRow item={item} key={item.idSoggetto} canAddSoggetto={false}  onAddSoggetto={this.props.onAddSoggetto} onDeleteSoggetto={this.props.onDeleteItem} readOnly={this.props.readOnly}/>
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>)
    }

}

RubricaTable.PropTypes = {
    items: PropTypes.array,
    senderList: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onAddSoggetto: PropTypes.func,
    onExportRubrica: PropTypes.func,
    onDeleteItem: PropTypes.func,
    readOnly: PropTypes.bool
}
export default RubricaTable;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaTable.js
 **/